import { render, staticRenderFns } from "./PlanoUpgrade.vue?vue&type=template&id=5b4f5f8b&"
import script from "./PlanoUpgrade.vue?vue&type=script&lang=js&"
export * from "./PlanoUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./PlanoUpgrade.vue?vue&type=style&index=0&id=5b4f5f8b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports